import { useEffect, useRef } from 'react';

export const useWindowEvent = ({ eventName, callback, args = [] }) => {
    /**
     * Ref to store the callback function and arguments. This ensures we always use the latest callback
     * and arguments without re-running the effect (removing and re-adding event listeners) when only
     * the callback reference or arguments changes.
     */
    const callbackRef = useRef(callback);
    const argsRef = useRef(args);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        argsRef.current = args;
    }, [args]);

    useEffect(() => {
        const handler = e => callbackRef.current(e, ...argsRef.current);
        window.addEventListener(eventName, handler);
        return () => {
            window.removeEventListener(eventName, handler);
        };
    }, [eventName]);
};
